/** Animation tokens aligned with cv_dr_django_last (framer-motion). */

export const easeOut = [0.22, 1, 0.36, 1] as const;

export const springHover = { type: "spring" as const, stiffness: 300 };

export const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: (i: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.15, ease: easeOut },
  }),
};

export const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: (i: number = 0) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: easeOut },
  }),
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

export const viewport = { once: false as const, margin: "-50px" as const };
